export default __webpack_public_path__ + "static/media/mecha_927_3.5eb9638d.jpg";